/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { ClassroomUserModifyGradeManualRequestViewModel } from "../types/ClassroomUserModifyGradeManualRequestViewModel.ts";
import { classroomUserModifyGradeManualViewModelSchema } from "./classroomUserModifyGradeManualViewModelSchema.ts";

export const classroomUserModifyGradeManualRequestViewModelSchema = z.object({
  grades: z
    .array(z.lazy(() => classroomUserModifyGradeManualViewModelSchema))
    .describe("Lista de notas a serem modificadas manualmente. Obrigatório.")
    .nullish(),
}) as unknown as ToZod<ClassroomUserModifyGradeManualRequestViewModel>;
